/**
 * Acces au stockage local, tolerant au renommage du produit.
 *
 * Le passage a Scan2Eat (ADR 0020) a change toutes les cles. Un convive attable
 * au moment du deploiement a sa session et son panier sous l'ancienne : les lire
 * lui evite de tout perdre au milieu de son repas.
 *
 * Le helper vit ici, et non dans `@scan2eat/shared`, parce que ce paquet est
 * aussi importe par l'API, qui n'a pas de `localStorage`.
 */

import { LEGACY_STORAGE_KEYS } from '@scan2eat/shared';

/**
 * Lit une cle, en retombant sur son ancien nom.
 *
 * La valeur trouvee sous l'ancien nom est recopiee sous le nouveau puis
 * effacee : la migration se fait a la premiere lecture, sans tache dediee.
 *
 * @deprecated Redeviendra un simple `localStorage.getItem` au deploiement
 * suivant, avec `LEGACY_STORAGE_KEYS`.
 */
export function readStoredValue(key: string): string | null {
  try {
    const current = localStorage.getItem(key);
    if (current !== null) return current;

    const legacyKey = LEGACY_STORAGE_KEYS[key];
    if (!legacyKey) return null;

    const legacy = localStorage.getItem(legacyKey);
    if (legacy === null) return null;

    localStorage.setItem(key, legacy);
    localStorage.removeItem(legacyKey);
    return legacy;
  } catch {
    // Navigation privee, stockage bloque : se comporter comme une absence.
    return null;
  }
}
